module.exports = __webpack_public_path__ + "media/images/emblems/Stuesslingen-blason-c524d43beba1f91649eb0e40763e5d3d.png";